module.exports = __webpack_public_path__ + "static/media/133-saudi-arabia.d873dd12.svg";